import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { IconButton, Tooltip } from '@mui/material';
import React from 'react';
import usePromoteDraftCart from '../../hooks/draftCart/usePromoteDraftCart.hooks';
import { borderCircleSx } from './borderCircleControl';

/** "item", not "line" — see `COPY_TO_DRAFT_LABEL`. These two are one journey. */
export const PROMOTE_LINE_LABEL = 'Add this item to the order';

interface PromoteLineControlProps {
  cartItemId: number;
}

/**
 * HITL-1615 — the copy control mirrored.
 *
 * Same 20px circle on the border, same hit pad, opposite edge and opposite
 * arrow: it points at the column the line is moving into. An icon costs no
 * vertical space, so a My Cart line stays one card tall in every mode and three
 * lines still fit the column — which a button row would not allow.
 *
 * Promotion MOVES the line, so this can never duplicate by double-press: the
 * second press has nothing to act on.
 *
 * `stopPropagation` for the same reason as the copy control — the row's own
 * click toggles its collapse.
 */
const PromoteLineControl = ({ cartItemId }: PromoteLineControlProps) => {
  const { promoteLine } = usePromoteDraftCart();

  const onPromote = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    promoteLine(cartItemId);
  };

  return (
    <Tooltip title={PROMOTE_LINE_LABEL} arrow disableInteractive>
      <IconButton
        aria-label={PROMOTE_LINE_LABEL}
        data-testid="promote-line"
        onClick={onPromote}
        onMouseDown={(e) => e.stopPropagation()}
        size="small"
        sx={borderCircleSx('right')}
      >
        <KeyboardDoubleArrowRightIcon />
      </IconButton>
    </Tooltip>
  );
};

export default PromoteLineControl;
